import { render, staticRenderFns } from "./massSend.vue?vue&type=template&id=737f63f5&scoped=true&"
import script from "./massSend.vue?vue&type=script&lang=js&"
export * from "./massSend.vue?vue&type=script&lang=js&"
import style0 from "./massSend.vue?vue&type=style&index=0&id=737f63f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737f63f5",
  null
  
)

export default component.exports